<div class="pass-select-dialog">
  <div class="dialog-header">
    <h2 class="dialog-title">Selecciona tu abono</h2>
    <button class="btn-close" (click)="cancel()">
      <i class="fa-light fa-times"></i>
    </button>
  </div>

  <div class="dialog-body">
    <!-- Pass list (only shown when multiple passes) -->
    <div *ngIf="passes.length > 1" class="passes-list">
      <p class="section-label">Abonos disponibles</p>
      <div class="pass-option"
           *ngFor="let pass of passes"
           [class.selected]="selectedPass?.id === pass.id"
           (click)="selectPass(pass)">
        <div class="pass-option-check">
          <i class="fa-light" [class]="selectedPass?.id === pass.id ? 'fa-circle-check' : 'fa-circle'"></i>
        </div>
        <div class="pass-option-info">
          <span class="pass-option-name">{{ pass.name }}</span>
          <span class="pass-option-meta">{{ getEventCount(pass) }} eventos</span>
        </div>
        <div class="pass-option-badge" *ngIf="getDiscountBadge(pass)">
          <i class="fa-light fa-tag"></i>
          <span>{{ getDiscountBadge(pass) }}</span>
        </div>
      </div>
    </div>

    <!-- Single pass info -->
    <div *ngIf="passes.length === 1 && selectedPass" class="pass-single-info">
      <div class="pass-name-row">
        <i class="fa-light fa-ticket pass-icon"></i>
        <span class="pass-single-name">{{ selectedPass.name }}</span>
        <span class="pass-option-badge" *ngIf="getDiscountBadge(selectedPass)">
          <i class="fa-light fa-tag"></i>
          {{ getDiscountBadge(selectedPass) }}
        </span>
      </div>
      <p class="pass-events-count" *ngIf="getEventCount(selectedPass) > 0">
        <i class="fa-light fa-calendar-alt"></i>
        {{ getEventCount(selectedPass) }} eventos incluidos
      </p>
    </div>

    <!-- Quantity selector -->
    <div class="quantity-section">
      <p class="section-label">¿Cuántos abonos?</p>
      <div class="quantity-selector">
        <button class="qty-btn" (click)="decreaseQty()" [disabled]="quantity <= 1">
          <i class="fa-light fa-minus"></i>
        </button>
        <span class="qty-value">{{ quantity }}</span>
        <button class="qty-btn" (click)="increaseQty()" [disabled]="quantity >= 10">
          <i class="fa-light fa-plus"></i>
        </button>
      </div>
      <p class="qty-hint" *ngIf="quantity > 1">
        Seleccionarás {{ quantity }} abono{{ quantity > 1 ? 's' : '' }} (1 entrada por evento y abono)
      </p>
    </div>
  </div>

  <div class="dialog-footer">
    <button class="btn-cancel" (click)="cancel()">Cancelar</button>
    <button class="btn-confirm primary-button solid"
            [disabled]="!selectedPass"
            (click)="confirm()">
      <i class="fa-light fa-arrow-right"></i>
      Continuar
    </button>
  </div>
</div>
